<template>
    <div style="width: 60%;margin: auto">
        <!--{{keyword}}-->
        <!--{{searchList}}-->

        <div class="article-list-main">
            <div class="article-list-container">
                <el-card class="article-list-item-container" v-for="(item,index) in searchList" :key="index">
                    <router-link class="article-list-item" :to="'/article/articleDetail/' + item.id" target="_blank">
                        <div @click="addViewCount(item.id)">
                            <h3 style="margin: 0px auto 6px">{{item.title}}</h3>
                        </div>
                    </router-link>
                    <div style="display: flex">
                        <p style="font-size: 14px;color: #6d6868;margin: 0">{{item.summary}}</p>
                    </div>
                </el-card>
            </div>

            <el-pagination
                    class="page"
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    @prev-click="handlePrevClick"
                    @next-click="handleNextClick"
                    :current-page="currentPage"
                    :page-sizes="[10 , 20, 30, 40 ,50 ,60]"
                    :page-size="30"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total=total>
            </el-pagination>

        </div>

    </div>
</template>

<script>
    import {search} from "@/api/search";

    export default {
        name: "Search",
        data(){
            return{
                keyword: '',
                searchList:[],
                total:0,
                currentPage: 1,
                pageNum:1,
                pageSize:30,
            }
        },
        watch: {
            /*监听路由变化*/
            $route:{
                handler(){
                    this.keyword = this.$route.params.keyword;
                    // this.$message({
                    //     showClose: true,
                    //     message: this.keyword,
                    //     type: 'success'
                    // });
                    this.search(this.pageNum,this.pageSize);
                },
                immediate: true
            }
        },
        created() {
            this.keyword = this.$route.params.keyword;
            // this.search(this.pageNum,this.pageSize);
        },
        methods: {
            handleSizeChange(val) {
                this.pageSize=val
                this.search(this.pageNum,val)
            },
            handleCurrentChange(val) {
                this.pageNum=val
                this.search(val,this.pageSize)
            },
            handlePrevClick(val){
                this.search(val,this.pageSize)
            },
            handleNextClick(val){
                this.search(val,this.pageSize)
            },

            search(pageNum,pageSize){
                search(this.keyword,pageNum,pageSize).then(response => {
                    // this.$message({
                    //     showClose: true,
                    //     message: response.message,
                    //     type: 'success'
                    // });
                    this.searchList = response.data.rows
                    this.total = response.data.total
                    // console.log(response)
                });
            },

        }
    }
</script>

<style scoped>
    /*.article-list-item-container{*/
        /*padding: 40px;*/
        /*margin: 20px;*/
    /*}*/
    .page{
        float: right;
        margin-right: 30px;
    }

    .article-list-item-container {
        /*border: #6495ED 1px solid;*/
        box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
        /*padding-bottom: 30px;*/
        /*padding-left: 30px;*/
        /*margin-bottom: 30px;*/
        /*background: #F7F7F7;*/
    }

    .article-list-item-container :hover{
        background: #f9f9f9;
    }

    .article-list-item :hover{
        color: #6495ED;
    }

    .article-list-item{
        text-decoration: none;
        color: black;
    }
</style>
